import {useSelector} from 'react-redux';
import useDeleteSaleAgent from '../../../../../../services/hookService/deleteSaleAgent/useDeleteSaleAgent';
import {RootState} from '../../../../../../store/redux';

interface IAdvertisementTypesBottomSheet {
  saleAgentsBottomSheet: ISaleAgentBottomSheetProps;
  setSaleAgentsBottomSheet: React.Dispatch<
    React.SetStateAction<ISaleAgentBottomSheetProps>
  >;
  refetchGetSaleAgentList?: () => void;
}

const DeleteSaleAgentBottomSheet = ({
  saleAgentsBottomSheet,
  setSaleAgentsBottomSheet,
  refetchGetSaleAgentList,
}: IAdvertisementTypesBottomSheet) => {
  const state = useSelector((state: RootState) => state.saleAgent);

  const handleClose = () => {
    setSaleAgentsBottomSheet({
      ...saleAgentsBottomSheet,
      position: false,
      type: '',
    });
  };
  const {mutate} = useDeleteSaleAgent({refetchGetSaleAgentList});

  return (
    <div className="px-4 py-3">
      <div className="flex justify-between mb-2">
        <span className="text-red-800">حذف فروشگاه {state.store_name}</span>
        <i className="icon-nameClose-remove" onClick={handleClose} />
      </div>
      <p className="pb-2">آیا اطمینان به حذف این فروشگاه دارید؟</p>
      <div className="flex flex-1 h-12 gap-2">
        <button
          disabled={state?.cardGuid === ''}
          className="flex-[2_2_0%] text-white bg-red-500 rounded"
          onClick={() => {
            state?.cardGuid && mutate(state?.cardGuid as string);
            handleClose();
          }}
        >
          بله، حذف
        </button>
        <button
          className="flex-1 rounded border-[1px] border-farm-shop-500 text-farm-shop-500"
          onClick={handleClose}
        >
          انصراف
        </button>
      </div>
    </div>
  );
};

export default DeleteSaleAgentBottomSheet;
